export const toggleMenu =
    ({ isMenuOpen, setIsMenuOpen }: { isMenuOpen: boolean; setIsMenuOpen: (isMenuOpen: boolean) => void }) =>
    (): void => {
        setIsMenuOpen(!isMenuOpen)
    }

export const getArrowDirection = (isMenuOpen: boolean): string => (isMenuOpen ? 'up' : 'down')
